module.exports = __webpack_public_path__ + "static/img/VVIP.2ac4f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VVIP.jpg
// module id = 8drq
// module chunks = 3